{
  "version": 1,
  "asset_id": "0c54d8d2-daef-4636-b4bc-34e7ba489746",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/0c54d8d2-daef-4636-b4bc-34e7ba489746/dr-fitzer-home-720.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/0c54d8d2-daef-4636-b4bc-34e7ba489746/dr-fitzer-home-720.webp",
  "original_filename": "dr-fitzer-home-720.webp",
  "size": 29918,
  "content_type": "image/webp",
  "created_at": "2026-07-23T12:02:00Z"
}
